import { render } from "./FormTwkView.vue?vue&type=template&id=c6621e12"
import script from "./FormTwkView.vue?vue&type=script&lang=js"
export * from "./FormTwkView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__